import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Status } from "../types";

type GetStatusParams = {
	locale?: string;
};

const fetchStatuses = async (locale: string = "en-us"): Promise<Status[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getStatuses",
		bind: {
			locale: locale.toLowerCase(),
		},
	});

	return response.data.result;
};

export const useGetStatuses = ({ locale }: GetStatusParams) => {
	return useQuery<Status[]>({
		queryKey: ["getStatuses", locale],
		queryFn: () => fetchStatuses(locale),
		select: (data) => {
			return data;
		},
	});
};
